/**
 * Created by matheusmorett on 27/03/18.
 */
import {observable, action} from 'mobx';
import Api from "utils/Api";
import moment from 'moment';
// registram os dados dos locales (efeito colateral global corrigido por syncMomentLocale abaixo)
import 'moment/locale/pt-br';
import 'moment/locale/es';

const SUPPORTED_LANGS = ['pt', 'en', 'es'];

class ApplicationStore {

    // Footer
    @observable footer = true;
    @observable newsletter = false;

    // Menu
    @observable menu = true;
    @observable menuBorder = false;
    @observable menuBackgroundWhite = false;
    @observable menuSearchButton = false;
    @observable menuRegister = true;
    @observable menuStyle = {};
    @observable menuTiny = false;
    @observable menuMobileOpen = false;

    // Login - Register
    @observable modal = false;
    @observable modalRegister = false;
    @observable modalLogin = false;
    @observable modalForgotPassword = false;
    @observable modalNotClosable = false;
    @observable reloadPageAfterLogin = true;

    // Page
    @observable pageBackground;
    @observable isMobile;
    @observable minimalTemplate = false;
    @observable tag_code;

    // Idioma do checkout (i18n leve): 'pt' | 'en' | 'es'. Fontes, da mais forte para a
    // mais fraca: escolha manual no seletor (persistida) > ?lang= da URL > meta do
    // carrinho/contexto de retorno > pt.
    @observable lang = 'pt';
    langManual = false;


    // Navigation
    @observable history;
    @observable redirect = {
        status: false,
        page: ""
    };

    constructor() {
        this.isMobile = (window.innerWidth <= 479);
        window.addEventListener("resize", this.updateDimensions);
        this.initLang();
    }

    @action
    initLang() {
        // 1) escolha manual persistida (seletor de idioma)
        try {
            if (sessionStorage.getItem('lang_manual') === '1') {
                const saved = this.normalizeLang(sessionStorage.getItem('lang'));
                if (saved) {
                    this.lang = saved;
                    this.langManual = true;
                    this.syncMomentLocale();
                    return;
                }
            }
        } catch (e) {
            // pass
        }
        // 2) ?lang= da URL atual (a meta do carrinho é aplicada pelo Checkout)
        let raw = null;
        try {
            const match = window.location.search.match(/[?&]lang=([A-Za-z_-]+)/i);
            if (match) raw = match[1];
        } catch (e) {
            // pass
        }
        if (raw) this.setLang(raw);
        else this.syncMomentLocale();
    }

    normalizeLang(raw) {
        if (typeof raw !== 'string') return null;
        const base = raw.toLowerCase().split(/[-_]/)[0];
        return SUPPORTED_LANGS.indexOf(base) === -1 ? null : base;
    }

    // Aceita 'en', 'en-US', 'es_MX'...; valor não suportado é ignorado (fica como está).
    // Fontes de contexto (URL remontada, meta do carrinho, retorno de gateway) não
    // sobrescrevem uma escolha manual do comprador; `manual: true` vem só do seletor.
    @action
    setLang(raw, manual = false) {
        const base = this.normalizeLang(raw);
        if (!base) return;
        if (this.langManual && !manual) return;
        this.lang = base;
        this.syncMomentLocale();
        if (manual) {
            this.langManual = true;
            try {
                sessionStorage.setItem('lang', base);
                sessionStorage.setItem('lang_manual', '1');
            } catch (e) {
                // pass
            }
            // mantém a URL coerente (F5, copiar link) sem recarregar
            try {
                const url = new URL(window.location.href);
                url.searchParams.set('lang', base);
                window.history.replaceState(null, '', url.toString());
            } catch (e) {
                // pass
            }
        }
    }

    // Sem PayPal configurado a experiência não oferece multi-idioma: volta tudo a pt-BR
    // (inclusive uma escolha manual persistida nesta sessão).
    @action
    resetLangToPt() {
        this.lang = 'pt';
        this.langManual = false;
        this.syncMomentLocale();
        try {
            sessionStorage.removeItem('lang');
            sessionStorage.removeItem('lang_manual');
        } catch (e) {
            // pass
        }
    }

    // Os imports de 'moment/locale/*' (aqui e em 6 arquivos legados, alguns em chunks lazy)
    // setam o locale global do moment como efeito colateral. Quem renderiza data na jornada
    // chama isto no mount para garantir o locale do idioma corrente.
    syncMomentLocale() {
        moment.locale(this.lang === 'pt' ? 'pt-br' : this.lang);
    }

    @action
    setRedirect(params) {
        this.redirect = params;
    }

    @action
    setTagCode(code) {
        this.tag_code = code
    }
    
    @action
    setHistory(history) {
        this.history = history;
    }

    @action
    setReloadPageAfterLogin() {
        this.reloadPageAfterLogin = true;
    }

    @action
    updateDimensions() {
        this.isMobile = (window.innerWidth <= 479);
    }

    @action
    setNewsletter() {
        this.newsletter = true;
    }

    @action
    setMinimalTemplate(withScroll = false) {
        this.minimalTemplate = true;
        if(!withScroll)
            document.body.classList.add('no-scrollbar')
    }

    @action
    unsetMinimalTemplate() {
        this.minimalTemplate = false;

        document.body.classList.remove('no-scrollbar')
    }

    @action
    unsetNewsletter() {
        this.newsletter = false;
    }

    @action
    setFooter() {
        this.footer = true;
    }

    @action
    unsetFooter() {
        this.footer = false;
    }


    @action
    setMenu() {
        this.menu = true;
    }
    
    unsetMenu() {
        this.menu = false;
    }

    @action
    setMenuBorder() {
        this.menuBorder = true;
    }

    @action
    unsetMenuBorder() {
        this.menuBorder = false;
    }

    @action
    setMenuBackgroundWhite() {
        this.menuBackgroundWhite = true;
    }

    @action
    unsetMenuBackgroundWhite() {
        this.menuBackgroundWhite = false;
    }

    @action
    setMenuSearchButton() {
        this.menuSearchButton = true;
    }

    @action
    unsetMenuSearchButton() {
        this.menuSearchButton = false;
    }

    @action
    setMenuRegister() {
        this.menuRegister = true;
    }

    @action
    unsetMenuRegister() {
        this.menuRegister = false;
    }

    @action
    setMenuStyle(params) {
        this.menuStyle = params;
    }

    @action
    resetMenuStyle() {
        this.menuStyle = {};
    }

    @action
    openModalLogin() {
        this.modal = true;
        this.modalLogin = true;
        this.modalRegister = false;
        this.modalForgotPassword = false;
    }

    @action
    closeModalLogin() {
        this.modal = false;
        this.modalLogin = false;
        this.modalRegister = false;
        this.modalForgotPassword = false;
    }

    @action
    openModalRegister() {
        this.modal = true;
        this.modalLogin = false;
        this.modalForgotPassword = false;
        this.modalRegister = true;
    }

    @action
    openModalForgotPassword() {
        this.modal = true;
        this.modalForgotPassword = true;
        this.modalLogin = false;
        this.modalRegister = false;
    }

    @action
    closeModal() {
        if(this.modalNotClosable === false) {
            this.modal = false;
        }
    }

    @action
    checkCookieAcceptance(ip) {
        return Api.call('/preference/cookies-acceptance', 'get', { ip })
        .then((res) => { 
            if(res.data)
                return res.data
            
            return false
        }).catch(err => {
            return false
        })
    }

    @action
    acceptCookies(ip) {
        return Api.call('/preference/accept-cookies', 'post', { ip })
        .then((res) => { 
            if(res.data)
                return res.data
            
            return false
        }).catch(err => {
            return false
        })
    }

    @action
    setPageBackground(background) {
        this.pageBackground = background;
    }

    @action
    unsetPageBackground() {
        this.pageBackground = null;
    }

    @action
    setMenuTiny() {
        this.menuTiny = true;
    }

    @action
    unsetMenuTiny() {
        this.menuTiny = false;
    }

    @action
    setMenuMobileOpen(menuMobileOpen) {
        this.menuMobileOpen = menuMobileOpen;
    }

    @action
    setModalNotClosable() {
        this.modalNotClosable = true;
    }

    @action
    unsetModalNotClosable() {
        this.modalNotClosable = false;
    }

}

export default new ApplicationStore();

